import React from 'react';

import Botones from '../../../components/UI/botonera/headerBotones.js';
import MonthYearPicker from '../../../components/UI/dataPicker/monthYearPicker.jsx'
import ComboBox from '../../../components/UI/comboBox/combobox.jsx';
import TablaFiltro from '../../../components/UI/tablaFiltro/tablaFiltroSort.jsx';
import Division from '../../../components/UI/division/division.jsx';
import FrmBotones from '../../../components/UI/botonera/formBotones.jsx';

import Config from "../../../components/Util/constantes.js";

function DesbloquearAsientoInt(props) {
    return (
        <>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>                            
                            <MonthYearPicker id="fecMesAno" col="4" pvalue={props.Datos.fecMesAno.value} attributes={props.Datos.fecMesAno.attributes} label={props.Datos.fecMesAno.attributes.label} handleChange={props.onhandleChangeDate} />
                            <ComboBox id="SelectedEstado" col="4" attributes={props.Datos.Estado.attributes} value={props.selectedEstado} label={props.Datos.Estado.attributes.label} datos={props.listaEstado} onChange={props.handleSelectEstado} />
                            <FrmBotones col="4" attributes={props.Datos.Botones.attributes} botones={props.botonFiltro} />
                        </div>
                        <div className="row">
                            <Division id="division" label={""} attributes={{}} />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <div id="master-tabla" className="table-responsive  col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <TablaFiltro
                                        columnas={props.columnas}
                                        datos={props.listaDatos}
                                        keyField={'id'}
                                        modo={props.cellEdit}                                        
                                        selectRow={props.selectRow}                                        
                                        nombreCSV={"Asientos"}                                        
                                        botones={[]}
                                        botonesLista={[]}
                                        busqueda={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </>
    );
}
export default DesbloquearAsientoInt;